module.exports = __webpack_public_path__ + "static/img/16.7e0a7c4e.png";